export const canAccessCRM = (account, currentUser, kanbanList = []) => {
  if (!account?.enable_crm) return false;

  if (
    currentUser?.type === 'SuperAdmin' ||
    currentUser?.type_role === 'administrator'
  ) {
    return true;
  }

  return kanbanList.some(
    kanban => kanban?.agents_ids?.includes(currentUser?.id) && kanban.active
  );
};
